import React, {useState} from "react";
import PlatformToggle from "components/PlatformToggle";
import {
  FOCUS_ARROW_HIDDEN_TYPE,
  FOCUS_ITEM_STYLE,
  FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT
} from "../enums";
import {Carousel} from "react-responsive-carousel";
import {RoundedCustomButton} from "../../../components/CustomIcon";
import ScrollLayoutDynamicArrow from "../../../components/ScrollLayoutDynamicArrow";

const CustomPresetsPreview = ({preset}) => {
  const [mobileView, setMobileView] = useState(true);

  const num_rows = (mobileView ? preset.rows : preset.rows_web) ?? 1;

  const isBannerStyle = preset.style === FOCUS_ITEM_STYLE.banner;
  const isHorizontalStyle = preset.style === FOCUS_ITEM_STYLE.horizontal;

  return (
    <>
      <div className="p-2 border-l-2 border-r-2 border-b-2 border-dashed py-5 mb-5">
        <div className="flex justify-center">
          <PlatformToggle mobileView={mobileView} mobileOnClick={() => setMobileView(true)}
                          webOnClick={() => setMobileView(false)}/>
        </div>

        <div className="flex justify-center mt-3">
          {/*<div style={{aspectRatio: `${(mobileView ? preset.ar : preset.ar_web) ?? 1}`}}*/}
          {/*  // key={`preview-${i}`}*/}
          {/*     className="border rounded-[3px] bg-secondary-100 w-full"/>*/}

          {isBannerStyle ?
            <DummyBannerPreview preset={preset} mobileView={mobileView}/> :
            isHorizontalStyle ?
              <HorizontalPreview preset={preset} mobileView={mobileView}/>
              : <div className={`grid gap-4 ${mobileView ? 'max-w-[414px]' : 'max-w-[600px]'} w-full`}
                     style={{gridTemplateColumns: `repeat(${num_rows}, minmax(0, 1fr))`}}>
                {Array.from({length: num_rows}, (_, i) =>
                  <div style={{aspectRatio: `${(mobileView ? preset.ar : preset.ar_web) ?? 1}`}} key={`preview-${i}`}
                       className="border rounded-[3px] bg-secondary-100"/>)}

              </div>
          }
        </div>

      </div>
    </>
  );
};

export default CustomPresetsPreview;

const DummyBannerPreview = ({preset, mobileView}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <div className={`${mobileView ? 'max-w-[414px]' : 'max-w-[600px]'} w-full relative`}>
      <Carousel showIndicators={false} showThumbs={false} showStatus={false} interval="7000" autoPlay={true}
                infiniteLoop={true} showArrows={false} className="w-full" selectedItem={currentSlide}
                onChange={setCurrentSlide} du>
        {Array.from({length: 2}, (_, i) =>
          <div style={{aspectRatio: `${(mobileView ? preset.ar : preset.ar_web) ?? 1}`, opacity: 1 / i + 1}}
               key={`banner-${i}`}
               className="border rounded-[3px] bg-secondary-100 w-full"/>
        )}

      </Carousel>

      <>
        <RoundedCustomButton size="2xl" className="right-10 absolute top-1/2 -translate-y-2/4"
                             icon="chevron_right" isLeft={false}
                             onClick={() => setCurrentSlide(currentSlide + 1)}/>
        <RoundedCustomButton size="2xl" className="left-10 absolute top-1/2 -translate-y-2/4"
                             icon="chevron_left"
                             onClick={() => setCurrentSlide(currentSlide - 1)}/>
      </>
    </div>
  );
};

const HorizontalPreview = ({preset, mobileView}) => {

  return (

    <div
      className={`${mobileView ? 'max-w-[414px]' : 'max-w-[600px]'} space-x-2 w-full flex `}>
      <ScrollLayoutDynamicArrow isNavOverlay={preset.arrow === FOCUS_ARROW_HIDDEN_TYPE[1].value}
        showNav={(!mobileView && preset.arrow !== FOCUS_ARROW_HIDDEN_TYPE[2].value)} isDefaultVisible={false} className="space-x-2">
        {Array.from({length: 10}, (_, i) =>
          <div style={{
            aspectRatio: `${(mobileView ? preset.ar : preset.ar_web) ?? 1}`,
            height: `${FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT * (mobileView ? preset.hf : preset.hf_web) ?? 1}px`
          }}
               key={`banner-${i}`}
               className="border rounded-[3px] bg-secondary-100"/>
        )}
      </ScrollLayoutDynamicArrow>


    </div>
  );
};
